import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { useUiStore } from '@/stores/ui.store';

/**
 * Arabic ⇄ English toggle (05 §6.1). Flipping the language rewrites `lang` and
 * `dir` on <html> — no reload — which is what `LanguageEffect` in `App.tsx` does
 * in response to this store change.
 */
export function LanguageToggle() {
  const { t } = useTranslation();
  const lang = useUiStore((state) => state.lang);
  const toggleLang = useUiStore((state) => state.toggleLang);

  const next = lang === 'ar' ? 'en' : 'ar';

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLang}
      aria-label={t('language.toggle')}
      title={t('language.toggle')}
      data-testid="language-toggle"
    >
      {t(next === 'en' ? 'language.switchToEn' : 'language.switchToAr')}
    </Button>
  );
}
